// i18n dictionary for Law Pilot (EN / FR / AR)
export const LANGS = [
  { code: "en", label: "EN", name: "English", dir: "ltr" },
  { code: "fr", label: "FR", name: "Français", dir: "ltr" },
  { code: "ar", label: "AR", name: "العربية", dir: "rtl" },
];

export const dict = {
  en: {
    brand: "Law Pilot",
    nav: { features: "How it works", knowledge: "Knowledge", pricing: "For companies", login: "Sign in", start: "Get started" },
    hero: {
      kicker: "AI legal support for companies in Lebanon",
      title_a: "Lebanese law,",
      title_b: "answered before",
      title_c: "the billable hour begins.",
      sub: "An AI assistant trained on Lebanon's Labour Code, Code of Commerce, Tax law and Commercial regulations. Get instant, sourced answers in English, French or Arabic — and know exactly when to call a lawyer.",
      cta_primary: "Start free consultation",
      cta_secondary: "Browse the knowledge base",
      disclaimer: "General information, not a substitute for licensed legal counsel.",
    },
    features: {
      title: "What you get",
      items: [
        { t: "Law Pilot — your AI counsel", d: "Ask in plain language. Get sourced answers citing exact articles of Lebanese law." },
        { t: "Curated knowledge base", d: "Hand-picked Q&A across Labour, Corporate, Tax and Commercial Code, in three languages." },
        { t: "Company-ready workspace", d: "Save consultations, bookmark articles, share with your team, switch languages on the fly." },
        { t: "Know when to escalate", d: "Law Pilot tells you when a matter genuinely needs a licensed Lebanese lawyer." },
      ],
    },
    how: {
      title: "Three steps to clarity",
      steps: [
        { n: "01", t: "Sign your company up", d: "Email + password, or Google. One account, the whole team." },
        { n: "02", t: "Ask anything", d: "From end-of-service indemnity calculations to SAL incorporation steps." },
        { n: "03", t: "Decide with confidence", d: "Sourced answers, saved consultations, and a clear path to engage counsel only when needed." },
      ],
    },
    cta: { title: "Bring legal clarity into the room before the lawyer enters it.", btn: "Create company account" },
    footer: "© Law Pilot. For informational use only.",
    auth: {
      sign_in: "Sign in", sign_up: "Create account",
      email: "Email", password: "Password", name: "Full name", company: "Company (optional)",
      have_acc: "Already have an account?", no_acc: "New here?",
      or: "OR",
      google: "Continue with Google",
      welcome_back: "Welcome back",
      create_title: "Create your company account",
      sub_in: "Sign in to access your legal consultations.",
      sub_up: "Start using Law Pilot, your Lebanese-law AI assistant.",
    },
    dash: {
      hi: "Bonsoir",
      ask_now: "Ask Law Pilot a question",
      placeholder: "e.g. How is end-of-service indemnity calculated for 8 years of service?",
      recent: "Recent consultations",
      no_chats: "No consultations yet. Start one above.",
      explore: "Explore the knowledge base",
      categories: "Categories",
    },
    chat: {
      title: "Legal consultation",
      placeholder: "Ask anything about Lebanese law…",
      send: "Send",
      thinking: "Law Pilot is reading the law…",
      empty_title: "Ask your first question",
      empty_sub: "Law Pilot answers in your selected language, citing the relevant Lebanese statute.",
      suggestions: [
        "Notice period for an employee with 7 years of service?",
        "What is the VAT registration threshold?",
        "How to incorporate an SAL — full steps?",
        "What is an arbitrary dismissal under Lebanese Labour Code?",
      ],
      new_chat: "New consultation",
      conversations: "Conversations",
      delete: "Delete",
      error_fallback: "We couldn't reach Law Pilot right now. Please try again in a moment.",
    },
    kb: {
      title: "Knowledge base",
      sub: "Curated Q&A on Lebanese Labour, Corporate, Tax and Commercial law.",
      search_ph: "Search questions, articles, tags…",
      all: "All",
      ref: "Reference",
      bookmark: "Bookmark",
      bookmarked: "Bookmarked",
    },
    bookmarks: { title: "Bookmarked articles", empty: "You haven't bookmarked anything yet." },
    settings: { title: "Settings", profile: "Profile", language: "Preferred language", save: "Save changes", saved: "Profile updated", signout: "Sign out", password: "Change password", currentPassword: "Current password", newPassword: "New password", updatePassword: "Update password", passwordUpdated: "Password updated" },
    common: { back: "Back", loading: "Loading…", disclaimer: "General information only. Consult a licensed Lebanese lawyer for binding advice." },
  },
  fr: {
    brand: "Law Pilot",
    nav: { features: "Comment ça marche", knowledge: "Base de connaissances", pricing: "Pour les entreprises", login: "Connexion", start: "Commencer" },
    hero: {
      kicker: "Assistance juridique IA pour les entreprises au Liban",
      title_a: "Le droit libanais,",
      title_b: "répondu avant",
      title_c: "que les honoraires ne commencent.",
      sub: "Un assistant IA formé au Code du travail libanais, au Code de commerce, à la fiscalité et aux règlements commerciaux. Des réponses instantanées et sourcées en anglais, français ou arabe — et la certitude de savoir quand appeler un avocat.",
      cta_primary: "Démarrer une consultation",
      cta_secondary: "Parcourir la base",
      disclaimer: "Information générale, ne remplace pas un conseil juridique.",
    },
    features: {
      title: "Ce que vous obtenez",
      items: [
        { t: "Law Pilot — votre conseil IA", d: "Posez vos questions en langage naturel. Réponses sourcées citant les articles précis du droit libanais." },
        { t: "Base de connaissances curatée", d: "Questions/réponses sélectionnées sur le Travail, les Sociétés, la Fiscalité et le Commerce, en trois langues." },
        { t: "Espace entreprise", d: "Sauvegardez vos consultations, créez des favoris, partagez avec votre équipe, changez de langue à la volée." },
        { t: "Savoir quand escalader", d: "Law Pilot vous dit quand le dossier requiert vraiment un avocat libanais." },
      ],
    },
    how: {
      title: "Trois étapes vers la clarté",
      steps: [
        { n: "01", t: "Inscrivez votre société", d: "Email + mot de passe, ou Google. Un seul compte, toute l’équipe." },
        { n: "02", t: "Demandez tout", d: "De l’indemnité de fin de service à la création d’une SAL." },
        { n: "03", t: "Décidez en confiance", d: "Réponses sourcées, consultations enregistrées, et le bon réflexe : engager un avocat seulement si nécessaire." },
      ],
    },
    cta: { title: "Apportez la clarté juridique avant même que l’avocat n’arrive.", btn: "Créer un compte entreprise" },
    footer: "© Law Pilot. À titre informatif uniquement.",
    auth: {
      sign_in: "Se connecter", sign_up: "Créer un compte",
      email: "Email", password: "Mot de passe", name: "Nom complet", company: "Société (optionnel)",
      have_acc: "Déjà un compte ?", no_acc: "Nouveau ici ?",
      or: "OU",
      google: "Continuer avec Google",
      welcome_back: "Heureux de vous revoir",
      create_title: "Créez votre compte entreprise",
      sub_in: "Connectez-vous pour accéder à vos consultations.",
      sub_up: "Commencez à utiliser Law Pilot, votre assistant en droit libanais.",
    },
    dash: {
      hi: "Bonsoir",
      ask_now: "Posez une question à Law Pilot",
      placeholder: "ex. Comment est calculée l’indemnité de fin de service pour 8 ans ?",
      recent: "Consultations récentes",
      no_chats: "Aucune consultation pour l’instant. Commencez ci-dessus.",
      explore: "Explorer la base de connaissances",
      categories: "Catégories",
    },
    chat: {
      title: "Consultation juridique",
      placeholder: "Demandez n’importe quoi sur le droit libanais…",
      send: "Envoyer",
      thinking: "Law Pilot lit la loi…",
      empty_title: "Posez votre première question",
      empty_sub: "Law Pilot répond dans votre langue en citant l’article libanais pertinent.",
      suggestions: [
        "Préavis pour un salarié avec 7 ans d’ancienneté ?",
        "Quel est le seuil d’assujettissement à la TVA ?",
        "Comment créer une SAL — étapes complètes ?",
        "Qu’est-ce qu’un licenciement abusif au Liban ?",
      ],
      new_chat: "Nouvelle consultation",
      conversations: "Consultations",
      delete: "Supprimer",
      error_fallback: "Nous n’avons pas pu joindre Law Pilot. Veuillez réessayer dans un instant.",
    },
    kb: {
      title: "Base de connaissances",
      sub: "Q&R sélectionnées sur le Travail, les Sociétés, la Fiscalité et le Commerce.",
      search_ph: "Rechercher questions, articles, mots-clés…",
      all: "Tout",
      ref: "Référence",
      bookmark: "Mettre en favori",
      bookmarked: "Favori",
    },
    bookmarks: { title: "Favoris", empty: "Aucun favori pour l’instant." },
    settings: { title: "Paramètres", profile: "Profil", language: "Langue préférée", save: "Enregistrer", saved: "Profil mis à jour", signout: "Se déconnecter", password: "Changer le mot de passe", currentPassword: "Mot de passe actuel", newPassword: "Nouveau mot de passe", updatePassword: "Mettre à jour", passwordUpdated: "Mot de passe mis à jour" },
    common: { back: "Retour", loading: "Chargement…", disclaimer: "Information générale. Consultez un avocat libanais pour un avis contraignant." },
  },
  ar: {
    brand: "لو بايلوت",
    nav: { features: "كيف يعمل", knowledge: "قاعدة المعرفة", pricing: "للشركات", login: "تسجيل الدخول", start: "ابدأ الآن" },
    hero: {
      kicker: "دعم قانوني بالذكاء الاصطناعي للشركات في لبنان",
      title_a: "القانون اللبناني،",
      title_b: "أجوبة قبل أن",
      title_c: "تبدأ الساعة المُحتسبة.",
      sub: "مساعد ذكاء اصطناعي مدرَّب على قانون العمل، قانون التجارة، الضرائب والقانون التجاري في لبنان. أجوبة فورية بمصادر، بالعربية أو الإنكليزية أو الفرنسية — وستعرف بالضبط متى تستعين بمحامٍ.",
      cta_primary: "ابدأ استشارة مجانية",
      cta_secondary: "تصفّح قاعدة المعرفة",
      disclaimer: "معلومات عامة، لا تُغني عن استشارة محامٍ مرخّص.",
    },
    features: {
      title: "ما الذي ستحصل عليه",
      items: [
        { t: "لو بايلوت — مستشارك الذكي", d: "اطرح سؤالك بلغة طبيعية واحصل على إجابات مع الاستشهاد بمواد القانون اللبناني." },
        { t: "قاعدة معرفة منتقاة", d: "أسئلة وأجوبة في قوانين العمل والشركات والضرائب والتجارة بثلاث لغات." },
        { t: "مساحة عمل للشركات", d: "احفظ الاستشارات، أنشئ مفضلة، شارك مع الفريق، وبدّل اللغة فوراً." },
        { t: "اعرف متى تتواصل مع محامٍ", d: "يخبرك لو بايلوت بصراحة متى يحتاج الأمر إلى محامٍ لبناني مرخّص." },
      ],
    },
    how: {
      title: "ثلاث خطوات نحو الوضوح",
      steps: [
        { n: "01", t: "سجّل شركتك", d: "بريد إلكتروني وكلمة سر، أو حساب جوجل. حساب واحد لكل الفريق." },
        { n: "02", t: "اسأل أي شيء", d: "من حساب تعويض نهاية الخدمة إلى خطوات تأسيس شركة مغفلة." },
        { n: "03", t: "قرّر بثقة", d: "إجابات موثّقة، استشارات محفوظة، ومسار واضح للاستعانة بمحامٍ عند الحاجة." },
      ],
    },
    cta: { title: "احصل على الوضوح القانوني قبل أن تدخل غرفة المحامي.", btn: "أنشئ حساب الشركة" },
    footer: "© لو بايلوت. لأغراض إعلامية فقط.",
    auth: {
      sign_in: "تسجيل الدخول", sign_up: "إنشاء حساب",
      email: "البريد الإلكتروني", password: "كلمة المرور", name: "الاسم الكامل", company: "الشركة (اختياري)",
      have_acc: "لديك حساب؟", no_acc: "جديد هنا؟",
      or: "أو",
      google: "المتابعة مع جوجل",
      welcome_back: "أهلاً بعودتك",
      create_title: "أنشئ حساب شركتك",
      sub_in: "سجّل الدخول للوصول إلى استشاراتك.",
      sub_up: "ابدأ باستخدام لو بايلوت، مستشارك في القانون اللبناني.",
    },
    dash: {
      hi: "مساء الخير",
      ask_now: "اطرح سؤالاً على لو بايلوت",
      placeholder: "مثلاً: كيف يُحتسب تعويض نهاية الخدمة لـ 8 سنوات؟",
      recent: "أحدث الاستشارات",
      no_chats: "لا استشارات بعد. ابدأ من الأعلى.",
      explore: "تصفّح قاعدة المعرفة",
      categories: "الفئات",
    },
    chat: {
      title: "استشارة قانونية",
      placeholder: "اسأل أي شيء عن القانون اللبناني…",
      send: "إرسال",
      thinking: "لو بايلوت يقرأ القانون…",
      empty_title: "اطرح سؤالك الأول",
      empty_sub: "يجيب لو بايلوت بلغتك مع الاستشهاد بالمادة اللبنانية المناسبة.",
      suggestions: [
        "ما هي مدة الإشعار لأجير مضى على عمله 7 سنوات؟",
        "ما حدّ التسجيل في ضريبة القيمة المضافة؟",
        "كيف يتم تأسيس شركة مغفلة لبنانية؟",
        "ما هو الصرف التعسفي في قانون العمل اللبناني؟",
      ],
      new_chat: "استشارة جديدة",
      conversations: "الاستشارات",
      delete: "حذف",
      error_fallback: "تعذّر الوصول إلى لو بايلوت الآن. يرجى المحاولة مجدّداً بعد قليل.",
    },
    kb: {
      title: "قاعدة المعرفة",
      sub: "أسئلة وأجوبة منتقاة في قوانين العمل والشركات والضرائب والتجارة.",
      search_ph: "ابحث في الأسئلة والمواد والوسوم…",
      all: "الكل",
      ref: "المرجع",
      bookmark: "أضف إلى المفضلة",
      bookmarked: "في المفضلة",
    },
    bookmarks: { title: "المفضلة", empty: "لا توجد مواد محفوظة بعد." },
    settings: { title: "الإعدادات", profile: "الملف الشخصي", language: "اللغة المفضّلة", save: "حفظ التغييرات", saved: "تم تحديث الملف", signout: "تسجيل الخروج", password: "تغيير كلمة المرور", currentPassword: "كلمة المرور الحالية", newPassword: "كلمة المرور الجديدة", updatePassword: "تحديث كلمة المرور", passwordUpdated: "تم تحديث كلمة المرور" },
    common: { back: "رجوع", loading: "جارٍ التحميل…", disclaimer: "معلومات عامة فقط. استشر محامياً لبنانياً للحصول على رأي ملزم." },
  },
};

export function t(lang, path) {
  const parts = path.split(".");
  let cur = dict[lang] || dict.en;
  for (const p of parts) {
    if (cur && typeof cur === "object" && p in cur) cur = cur[p];
    else return path;
  }
  return cur;
}
